module.exports = __webpack_public_path__ + "static/media/undraw_Brainstorming_akrv.11c72931.svg";